module.exports = __webpack_public_path__ + "media/images/Diminution CO2-53bf225644f23daa8210bcadd926fd48.svg";